import { Button } from "components/DesignSystem/Button/Button";
import { BareInput } from "components/DesignSystem/Input/Input";
import { EditPencil } from "components/icons/EditPencil";
import { useState } from "react";

type BrandNameBoxProps = {
  companyName: string;
  onChange: (name: string) => void;
};

export const BrandNameBox = ({ companyName, onChange }: BrandNameBoxProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [input, setInput] = useState("");

  const handleEdit = () => {
    setInput(companyName);
    setIsEditing(true);
  };

  const handleSave = () => {
    onChange(input.trim());
    setIsEditing(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") handleSave();
  };

  return (
    <div className="t-flex t-items-center t-gap-2">
      <span className="t-text-body t-text-neutral-40">Brand name:</span>
      {isEditing ? (
        <>
          <div className="t-w-60">
            <BareInput
              customSize="small"
              autoFocus
              placeholder="Brand name"
              value={input}
              onChange={(event) => setInput(event.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
          <Button
            type="button"
            customType="primary"
            size="small"
            onClick={handleSave}
            disabled={!input.trim()}
          >
            Save
          </Button>
          <Button
            type="button"
            customType="ghost"
            size="small"
            onClick={() => setIsEditing(false)}
          >
            Cancel
          </Button>
        </>
      ) : (
        <>
          <span className="t-text-body t-font-medium t-text-text-60">
            {companyName}
          </span>
          <Button
            customType="ghost_icon"
            size="xxsmall"
            type="button"
            className="t-text-text-30 hover:t-text-text-60"
            onClick={handleEdit}
          >
            <EditPencil />
          </Button>
        </>
      )}
    </div>
  );
};
